import { useHistory } from 'react-router';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import { ReactComponent as CaptureSelfie } from '../assets/CaptureSelfie.svg';
import { IncodeFooter } from '../components/IncodeFooter';
import { IncodeHeader } from '../components/IncodeHeader';
import { INCODE_ANALYTICS } from '../IncodeAnalytics';

import LocalTexts from './Incode.texts.json';

import styles from './IncodeCaptureSelfie.module.scss';

const LocalT = new MDText(LocalTexts.selfie);

const CTA = LocalT.translate('cta') as string;

export const IncodeCaptureSelfieTutorial = () => {
  const history = useHistory();

  return (
    <>
      <IncodeHeader instructions={LocalT.translate('instructions')} title={LocalT.translate('title')} />
      <figure className={styles.illustration}>
        <CaptureSelfie />
      </figure>
      <IncodeFooter>
        <Button
          fullWidth
          label={CTA}
          onClick={() => {
            INCODE_ANALYTICS.INCODE_CTA_CLICK({
              button_label: CTA,
              name: 'incode_selfie_tips_clicked',
            });

            history.push(
              {
                pathname: globalThis.location.pathname,
                state: { incode: true },
              },
            );
          }}
        />
      </IncodeFooter>
    </>
  );
};
